define('app/sdc/bind/sdc-bind-factory',[],function () {
	"use strict";
	// !Important!: Must not use with properties that have "$" will not
	return sdcBindFactory
	function sdcBindFactory(options) {
		options = options || angular.empty;
		return angular.extend(bindingDirectiveConstructor, {
			$inject: ["$name"],
			requiresTemplate: false
		});
		function bindingDirectiveConstructor($name) {
			return angular.extend({
				restrict: "A",
				scope: false,
				template: null
			},
			options,
			angular.extend({}, (options || angular.empty).controller, {
				controller: {
					bind: angular.extend({}, ((options || angular.empty).controller || angular.empty).bind, {
						"$value": "=" + (options.shallow ? "*" : "") + $name
					})
				}
			})
			);
		}
	}
});
